import { render, staticRenderFns } from "./picEditType.vue?vue&type=template&id=71aa99b4&scoped=true&"
import script from "./picEditType.vue?vue&type=script&lang=js&"
export * from "./picEditType.vue?vue&type=script&lang=js&"
import style0 from "./picEditType.vue?vue&type=style&index=0&id=71aa99b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71aa99b4",
  null
  
)

component.options.__file = "picEditType.vue"
export default component.exports